// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Homepagerightsidebar_Contributers__tztLO {
  padding: 10px 0px 10px 0px;
  display: flex;
  justify-content: space-around;
  flex-wrap: wrap;
  background-color: #ffffff;
  border: none;
  border-radius: 20px;
  padding: 15px;
  border: solid 1px #dee0e1;
}

.Homepagerightsidebar_contributersProfile__96JOK {
  display: flex;
  flex-wrap: wrap;
  max-width: 180px;
}

.Homepagerightsidebar_Arrow__wIqqV {
  align-self: center;
  padding: 4px;
  color: black;

  font-size: x-large;
}

.Homepagerightsidebar_ProfileImage__MYxAV {
  width: 46px;
  height: 46px;
  margin: 5px 10px;
  margin-bottom: 10px;
}
.Homepagerightsidebar_carousel-inner__TKTaG {
  width: 90% !important;
}
.Homepagerightsidebar_ShareUpdate__Z3MV9 {
  height: 58px;
  margin: 10px 0px 0px 0px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  /* background-color: #efeeed; */
  background-color: #ffffff;
  border: none;
  border-radius: 20px;
  border: solid 1px #dee0e1;
  font-weight: 00;
  font-size: 20px;
  padding: 12px 26px;
  cursor: pointer;
  /* text-transform: capitalize; */
}
.Homepagerightsidebar_homePageRightSideBar__\\+lOWM{
  /* background-color: #efeeed !important; */
  background-color: #ffffff !important;
}

.Homepagerightsidebar_ShareUpdate__Z3MV9 > h5 {
  margin: 0;
}

.Homepagerightsidebar_CreateTag__zlbf4 {
  height: 58px;
  margin: 10px 0px 0px 0px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: #ffffff;
  border: none;
  border-radius: 20px;
  border: solid 1px #dee0e1;
  font-weight: 00;
  font-size: 20px;
  padding: 12px 26px;
  cursor: pointer;
}

.Homepagerightsidebar_CreateTag__zlbf4 > h5 {
  margin: 0;
}

.Homepagerightsidebar_trendingTagsAsks__uvBwg {
  justify-content: flex-start;
  margin: 12px 0px 25px 0px;
  padding: 26px;
  background-color: #efeeed;
  border: solid 1px #dee0e1;
  border-radius: 20px;
  height: 200px;
  overflow-y: scroll;
  scroll-behavior: smooth;
  scrollbar-width: none;
}

.Homepagerightsidebar_trendingTagsAsks__uvBwg h2 {
  font-size: 20px;
}

.Homepagerightsidebar_Trending__nJw2- {
  padding: 26px;
  margin: 10px 0px 0px 0px;
  background-color: #ffffff;
  border: none;
  border-radius: 20px;
  border: solid 1px #dee0e1;
  padding-bottom: 0px;
}
.Homepagerightsidebar_tagSection__jsvi3 {
  margin-left: 0px !important;
  margin-top: 10px !important;
  margin-bottom: 10px !important;
}

.Homepagerightsidebar_Trending__nJw2- h2 {
  font-size: 16px;
  font-weight: 700;
  color: #373334;
}

.Homepagerightsidebar_Trending__nJw2- p {
  padding: 0;
  margin: 0;
}
.Homepagerightsidebar_Trending__nJw2- h6 {
  color: #373334;
  font-size: 14px;
  font-weight: 800;
}
.Homepagerightsidebar_Trending__nJw2- > div {
  margin: 10px 0 0 10px;
  clear: both;
}
.Homepagerightsidebar_Seemore__CqHNm {
  color: #373334;
  font-size: 10px;
  font-weight: bold;
  display: flex;
  align-items: center;
  justify-content: flex-end;
}
.Homepagerightsidebar_Seemore__CqHNm svg {
  position: relative;
  top: 0px;
  left: 4px;
}
.Homepagerightsidebar_asks__SODPP {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  list-style-type: none;
  padding: 0px;
  cursor: pointer;
  /* margin: 0px -15px; */
}

.Homepagerightsidebar_asks__SODPP > li {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: flex-start;
  min-height: 60px;
  border-radius: 15px;
  padding: 10px 4px;
  width: 100%;
  margin-bottom: -6px;
  /* box-shadow: 0px 2px 5px rgb(163, 177, 182); */
  background-color: #ffffff;
}

.Homepagerightsidebar_asks__SODPP > li > p {
  margin-left: 30px;
  /* padding: 5px; */
}

.Homepagerightsidebar_asksection__-M1su {
  margin-left: 0px !important;
  /* margin-top: 22px !important; */
  margin-bottom: 30px !important;
  padding-left: 4px;
}
.Homepagerightsidebar_asksection__-M1su h6 {
  margin-bottom: 5px;
}

.Homepagerightsidebar_asksection__-M1su > p {
  padding-top: 40px;
}

.Homepagerightsidebar_trendingAsks__6kbW2 {
  padding: 10px;
}
.Homepagerightsidebar_CreateTag__zlbf4 > p {
  color: black;
}

.Homepagerightsidebar_contributersavatar__mu73F {
  width: 46px !important;
  height: 46px !important;
}

.Homepagerightsidebar_avatarrow__sjrH5 {
  justify-content: center;
}
.Homepagerightsidebar_askavatar__gntBq {
  position: relative !important;
  border-radius: 40px !important;
  width: 45px !important;
  height: 45px !important;
  flex-shrink: 0;
}
.Homepagerightsidebar_askprofilecontnet__zOPTm {
  margin-left: 10px;
  margin-top: -3px;
}
.Homepagerightsidebar_askprofilecontnetName__0AOwa {
  font-weight: 700;
  font-size: 15px;
  color: #373334;
  word-break: break-all;
  /* line-height: 1.2; */
}
.Homepagerightsidebar_askprofilecontnetMessage__IXnYa {
  font-weight: 400;
  font-size: 13px;
  color: #373334;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden; /* Required for ellipsis */
  text-overflow: ellipsis; /* Correct property for ellipsis */
  word-break: break-word;
}

.Homepagerightsidebar_contributertick__meYlg {
  display: flex;
  flex-direction: row;
  align-items: center;
}
.Homepagerightsidebar_contributertick__meYlg p {
  font-size: 18px;
  color: #373334;
  font-weight: 700;
}
.Homepagerightsidebar_contributertick__meYlg > img {
  margin-left: 5px;
  margin-top: -13px;
}
@media all and (max-width: 768px) {
  .Homepagerightsidebar_rightSidebar__ziK\\+A {
    padding: 10px;
  }
}
.Homepagerightsidebar_profilehover__ABw55 {
  display: block;
  position: absolute;
  left: 10%;
  min-width: 240px;
  z-index: 10;
  background: white 0% 0% no-repeat padding-box !important;
  box-shadow: 0px 6px 16px rgba(0, 0, 0, 0.18) !important;
  border: 1px solid #e0e0e0;
  border-radius: 15px;
  padding: 15px;
  font-size: 12px;
  font-weight: 400;
}

.Homepagerightsidebar_profilehover__ABw55::before {
  content: "";
  position: absolute;
  top: -10px;
  left: var(--pointer-left, 24px);
  border-width: 0 8px 10px 8px;
  border-style: solid;
  border-color: transparent transparent #e0e0e0 transparent;
  filter: drop-shadow(0px -1px 1px rgba(0, 0, 0, 0.08));
}

.Homepagerightsidebar_profilehover__ABw55::after {
  content: "";
  position: absolute;
  top: -8px;
  left: var(--pointer-left, 24px);
  border-width: 0 8px 10px 8px;
  border-style: solid;
  border-color: transparent transparent white transparent;
}

@media all and (min-width: 769px) and (max-width: 920px) {
  .Homepagerightsidebar_profilehover__ABw55 {
    left: -20%;
  }
}
.Homepagerightsidebar_tagName__BmPex {
  word-break: break-all;
  font-family: sans-serif;
  font-weight: 500;
  font-size: 15px;
  color: #373334;
  cursor: pointer;
  text-decoration: underline;
  margin-bottom: -8px !important;
}
.Homepagerightsidebar_tagNameClicked__lY9AV {
  word-break: break-all;
  font-family: sans-serif;
  font-weight: 500;
  font-size: 15px;
  color: #4795de;
  cursor: pointer;
  text-decoration: underline;
  margin-bottom: -3px !important;
}
.Homepagerightsidebar_trendingTagNameContainer__6cmd6 {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: flex-start;
  margin-bottom: 8px;
}
.Homepagerightsidebar_trendingTagNameContainer__6cmd6 p {
  margin-bottom: -10px;
  text-decoration: underline;
  font-size: 14px;
}
.Homepagerightsidebar_trendingTagPrivateStatus__Wv8Hl {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  height: 12px;
  width: 12px;
  border-style: solid;
  border-width: 2px;
  border-radius: 30px;
  border-color: #999999;
  color: #999999;
  margin-left: 4px;
  font-size: 10px;
  padding: 5px;
  margin-bottom: 6px;
}
.Homepagerightsidebar_askImageContainer__nKCzB{
  position: relative;
}
.Homepagerightsidebar_crownSymbol__GnA5D {
  position: absolute;
  bottom: 0;
  right: 0;        
  width: 15px;       
  height: 15px;
}

`, "",{"version":3,"sources":["webpack://./src/Assets/css/home/Homepagerightsidebar.module.css"],"names":[],"mappings":"AAAA;EACE,0BAA0B;EAC1B,aAAa;EACb,6BAA6B;EAC7B,eAAe;EACf,yBAAyB;EACzB,YAAY;EACZ,mBAAmB;EACnB,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,YAAY;;EAEZ,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,YAAY;EACZ,wBAAwB;EACxB,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,+BAA+B;EAC/B,yBAAyB;EACzB,YAAY;EACZ,mBAAmB;EACnB,yBAAyB;EACzB,eAAe;EACf,eAAe;EACf,kBAAkB;EAClB,eAAe;EACf,gCAAgC;AAClC;AACA;EACE,0CAA0C;EAC1C,oCAAoC;AACtC;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,YAAY;EACZ,wBAAwB;EACxB,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,yBAAyB;EACzB,YAAY;EACZ,mBAAmB;EACnB,yBAAyB;EACzB,eAAe;EACf,eAAe;EACf,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,2BAA2B;EAC3B,yBAAyB;EACzB,aAAa;EACb,yBAAyB;EACzB,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,kBAAkB;EAClB,uBAAuB;EACvB,qBAAqB;AACvB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,wBAAwB;EACxB,yBAAyB;EACzB,YAAY;EACZ,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;AACrB;AACA;EACE,2BAA2B;EAC3B,2BAA2B;EAC3B,8BAA8B;AAChC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,UAAU;EACV,SAAS;AACX;AACA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,qBAAqB;EACrB,WAAW;AACb;AACA;EACE,cAAc;EACd,eAAe;EACf,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,yBAAyB;AAC3B;AACA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;AACX;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,uBAAuB;EACvB,qBAAqB;EACrB,YAAY;EACZ,eAAe;EACf,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,2BAA2B;EAC3B,uBAAuB;EACvB,gBAAgB;EAChB,mBAAmB;EACnB,iBAAiB;EACjB,WAAW;EACX,mBAAmB;EACnB,gDAAgD;EAChD,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,2BAA2B;EAC3B,iCAAiC;EACjC,8BAA8B;EAC9B,iBAAiB;AACnB;AACA;EACE,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;AACf;AACA;EACE,YAAY;AACd;;AAEA;EACE,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;AACzB;AACA;EACE,6BAA6B;EAC7B,8BAA8B;EAC9B,sBAAsB;EACtB,uBAAuB;EACvB,cAAc;AAChB;AACA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,qBAAqB;EACrB,sBAAsB;AACxB;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,oBAAoB;EACpB,qBAAqB;EACrB,aAAa;EACb,4BAA4B;EAC5B,gBAAgB,EAAE,0BAA0B;EAC5C,uBAAuB,EAAE,kCAAkC;EAC3D,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE;IACE,aAAa;EACf;AACF;AACA;EACE,cAAc;EACd,kBAAkB;EAClB,SAAS;EACT,gBAAgB;EAChB,WAAW;EACX,wDAAwD;EACxD,uDAAuD;EACvD,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,+BAA+B;EAC/B,4BAA4B;EAC5B,mBAAmB;EACnB,yDAAyD;EACzD,qDAAqD;AACvD;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,+BAA+B;EAC/B,4BAA4B;EAC5B,mBAAmB;EACnB,uDAAuD;AACzD;;AAEA;EACE;IACE,UAAU;EACZ;AACF;AACA;EACE,qBAAqB;EACrB,uBAAuB;EACvB,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,eAAe;EACf,0BAA0B;EAC1B,8BAA8B;AAChC;AACA;EACE,qBAAqB;EACrB,uBAAuB;EACvB,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,eAAe;EACf,0BAA0B;EAC1B,8BAA8B;AAChC;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,2BAA2B;EAC3B,uBAAuB;EACvB,kBAAkB;AACpB;AACA;EACE,oBAAoB;EACpB,0BAA0B;EAC1B,eAAe;AACjB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;EACZ,WAAW;EACX,mBAAmB;EACnB,iBAAiB;EACjB,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,YAAY;EACZ,kBAAkB;AACpB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,WAAW;EACX,YAAY;AACd","sourcesContent":[".Contributers {\r\n  padding: 10px 0px 10px 0px;\r\n  display: flex;\r\n  justify-content: space-around;\r\n  flex-wrap: wrap;\r\n  background-color: #ffffff;\r\n  border: none;\r\n  border-radius: 20px;\r\n  padding: 15px;\r\n  border: solid 1px #dee0e1;\r\n}\r\n\r\n.contributersProfile {\r\n  display: flex;\r\n  flex-wrap: wrap;\r\n  max-width: 180px;\r\n}\r\n\r\n.Arrow {\r\n  align-self: center;\r\n  padding: 4px;\r\n  color: black;\r\n\r\n  font-size: x-large;\r\n}\r\n\r\n.ProfileImage {\r\n  width: 46px;\r\n  height: 46px;\r\n  margin: 5px 10px;\r\n  margin-bottom: 10px;\r\n}\r\n.carousel-inner {\r\n  width: 90% !important;\r\n}\r\n.ShareUpdate {\r\n  height: 58px;\r\n  margin: 10px 0px 0px 0px;\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  /* background-color: #efeeed; */\r\n  background-color: #ffffff;\r\n  border: none;\r\n  border-radius: 20px;\r\n  border: solid 1px #dee0e1;\r\n  font-weight: 00;\r\n  font-size: 20px;\r\n  padding: 12px 26px;\r\n  cursor: pointer;\r\n  /* text-transform: capitalize; */\r\n}\r\n.homePageRightSideBar{\r\n  /* background-color: #efeeed !important; */\r\n  background-color: #ffffff !important;\r\n}\r\n\r\n.ShareUpdate > h5 {\r\n  margin: 0;\r\n}\r\n\r\n.CreateTag {\r\n  height: 58px;\r\n  margin: 10px 0px 0px 0px;\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  background-color: #ffffff;\r\n  border: none;\r\n  border-radius: 20px;\r\n  border: solid 1px #dee0e1;\r\n  font-weight: 00;\r\n  font-size: 20px;\r\n  padding: 12px 26px;\r\n  cursor: pointer;\r\n}\r\n\r\n.CreateTag > h5 {\r\n  margin: 0;\r\n}\r\n\r\n.trendingTagsAsks {\r\n  justify-content: flex-start;\r\n  margin: 12px 0px 25px 0px;\r\n  padding: 26px;\r\n  background-color: #efeeed;\r\n  border: solid 1px #dee0e1;\r\n  border-radius: 20px;\r\n  height: 200px;\r\n  overflow-y: scroll;\r\n  scroll-behavior: smooth;\r\n  scrollbar-width: none;\r\n}\r\n\r\n.trendingTagsAsks h2 {\r\n  font-size: 20px;\r\n}\r\n\r\n.Trending {\r\n  padding: 26px;\r\n  margin: 10px 0px 0px 0px;\r\n  background-color: #ffffff;\r\n  border: none;\r\n  border-radius: 20px;\r\n  border: solid 1px #dee0e1;\r\n  padding-bottom: 0px;\r\n}\r\n.tagSection {\r\n  margin-left: 0px !important;\r\n  margin-top: 10px !important;\r\n  margin-bottom: 10px !important;\r\n}\r\n\r\n.Trending h2 {\r\n  font-size: 16px;\r\n  font-weight: 700;\r\n  color: #373334;\r\n}\r\n\r\n.Trending p {\r\n  padding: 0;\r\n  margin: 0;\r\n}\r\n.Trending h6 {\r\n  color: #373334;\r\n  font-size: 14px;\r\n  font-weight: 800;\r\n}\r\n.Trending > div {\r\n  margin: 10px 0 0 10px;\r\n  clear: both;\r\n}\r\n.Seemore {\r\n  color: #373334;\r\n  font-size: 10px;\r\n  font-weight: bold;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: flex-end;\r\n}\r\n.Seemore svg {\r\n  position: relative;\r\n  top: 0px;\r\n  left: 4px;\r\n}\r\n.asks {\r\n  display: flex;\r\n  flex-direction: column;\r\n  justify-content: center;\r\n  align-items: flex-start;\r\n  list-style-type: none;\r\n  padding: 0px;\r\n  cursor: pointer;\r\n  /* margin: 0px -15px; */\r\n}\r\n\r\n.asks > li {\r\n  display: flex;\r\n  flex-direction: row;\r\n  justify-content: flex-start;\r\n  align-items: flex-start;\r\n  min-height: 60px;\r\n  border-radius: 15px;\r\n  padding: 10px 4px;\r\n  width: 100%;\r\n  margin-bottom: -6px;\r\n  /* box-shadow: 0px 2px 5px rgb(163, 177, 182); */\r\n  background-color: #ffffff;\r\n}\r\n\r\n.asks > li > p {\r\n  margin-left: 30px;\r\n  /* padding: 5px; */\r\n}\r\n\r\n.asksection {\r\n  margin-left: 0px !important;\r\n  /* margin-top: 22px !important; */\r\n  margin-bottom: 30px !important;\r\n  padding-left: 4px;\r\n}\r\n.asksection h6 {\r\n  margin-bottom: 5px;\r\n}\r\n\r\n.asksection > p {\r\n  padding-top: 40px;\r\n}\r\n\r\n.trendingAsks {\r\n  padding: 10px;\r\n}\r\n.CreateTag > p {\r\n  color: black;\r\n}\r\n\r\n.contributersavatar {\r\n  width: 46px !important;\r\n  height: 46px !important;\r\n}\r\n\r\n.avatarrow {\r\n  justify-content: center;\r\n}\r\n.askavatar {\r\n  position: relative !important;\r\n  border-radius: 40px !important;\r\n  width: 45px !important;\r\n  height: 45px !important;\r\n  flex-shrink: 0;\r\n}\r\n.askprofilecontnet {\r\n  margin-left: 10px;\r\n  margin-top: -3px;\r\n}\r\n.askprofilecontnetName {\r\n  font-weight: 700;\r\n  font-size: 15px;\r\n  color: #373334;\r\n  word-break: break-all;\r\n  /* line-height: 1.2; */\r\n}\r\n.askprofilecontnetMessage {\r\n  font-weight: 400;\r\n  font-size: 13px;\r\n  color: #373334;\r\n  display: -webkit-box;\r\n  -webkit-line-clamp: 2;\r\n  line-clamp: 2;\r\n  -webkit-box-orient: vertical;\r\n  overflow: hidden; /* Required for ellipsis */\r\n  text-overflow: ellipsis; /* Correct property for ellipsis */\r\n  word-break: break-word;\r\n}\r\n\r\n.contributertick {\r\n  display: flex;\r\n  flex-direction: row;\r\n  align-items: center;\r\n}\r\n.contributertick p {\r\n  font-size: 18px;\r\n  color: #373334;\r\n  font-weight: 700;\r\n}\r\n.contributertick > img {\r\n  margin-left: 5px;\r\n  margin-top: -13px;\r\n}\r\n@media all and (max-width: 768px) {\r\n  .rightSidebar {\r\n    padding: 10px;\r\n  }\r\n}\r\n.profilehover {\r\n  display: block;\r\n  position: absolute;\r\n  left: 10%;\r\n  min-width: 240px;\r\n  z-index: 10;\r\n  background: white 0% 0% no-repeat padding-box !important;\r\n  box-shadow: 0px 6px 16px rgba(0, 0, 0, 0.18) !important;\r\n  border: 1px solid #e0e0e0;\r\n  border-radius: 15px;\r\n  padding: 15px;\r\n  font-size: 12px;\r\n  font-weight: 400;\r\n}\r\n\r\n.profilehover::before {\r\n  content: \"\";\r\n  position: absolute;\r\n  top: -10px;\r\n  left: var(--pointer-left, 24px);\r\n  border-width: 0 8px 10px 8px;\r\n  border-style: solid;\r\n  border-color: transparent transparent #e0e0e0 transparent;\r\n  filter: drop-shadow(0px -1px 1px rgba(0, 0, 0, 0.08));\r\n}\r\n\r\n.profilehover::after {\r\n  content: \"\";\r\n  position: absolute;\r\n  top: -8px;\r\n  left: var(--pointer-left, 24px);\r\n  border-width: 0 8px 10px 8px;\r\n  border-style: solid;\r\n  border-color: transparent transparent white transparent;\r\n}\r\n\r\n@media all and (min-width: 769px) and (max-width: 920px) {\r\n  .profilehover {\r\n    left: -20%;\r\n  }\r\n}\r\n.tagName {\r\n  word-break: break-all;\r\n  font-family: sans-serif;\r\n  font-weight: 500;\r\n  font-size: 15px;\r\n  color: #373334;\r\n  cursor: pointer;\r\n  text-decoration: underline;\r\n  margin-bottom: -8px !important;\r\n}\r\n.tagNameClicked {\r\n  word-break: break-all;\r\n  font-family: sans-serif;\r\n  font-weight: 500;\r\n  font-size: 15px;\r\n  color: #4795de;\r\n  cursor: pointer;\r\n  text-decoration: underline;\r\n  margin-bottom: -3px !important;\r\n}\r\n.trendingTagNameContainer {\r\n  display: flex;\r\n  flex-direction: row;\r\n  justify-content: flex-start;\r\n  align-items: flex-start;\r\n  margin-bottom: 8px;\r\n}\r\n.trendingTagNameContainer p {\r\n  margin-bottom: -10px;\r\n  text-decoration: underline;\r\n  font-size: 14px;\r\n}\r\n.trendingTagPrivateStatus {\r\n  display: flex;\r\n  flex-direction: row;\r\n  justify-content: center;\r\n  align-items: center;\r\n  height: 12px;\r\n  width: 12px;\r\n  border-style: solid;\r\n  border-width: 2px;\r\n  border-radius: 30px;\r\n  border-color: #999999;\r\n  color: #999999;\r\n  margin-left: 4px;\r\n  font-size: 10px;\r\n  padding: 5px;\r\n  margin-bottom: 6px;\r\n}\r\n.askImageContainer{\r\n  position: relative;\r\n}\r\n.crownSymbol {\r\n  position: absolute;\r\n  bottom: 0;\r\n  right: 0;        \r\n  width: 15px;       \r\n  height: 15px;\r\n}\r\n\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"Contributers": `Homepagerightsidebar_Contributers__tztLO`,
	"contributersProfile": `Homepagerightsidebar_contributersProfile__96JOK`,
	"Arrow": `Homepagerightsidebar_Arrow__wIqqV`,
	"ProfileImage": `Homepagerightsidebar_ProfileImage__MYxAV`,
	"carousel-inner": `Homepagerightsidebar_carousel-inner__TKTaG`,
	"ShareUpdate": `Homepagerightsidebar_ShareUpdate__Z3MV9`,
	"homePageRightSideBar": `Homepagerightsidebar_homePageRightSideBar__+lOWM`,
	"CreateTag": `Homepagerightsidebar_CreateTag__zlbf4`,
	"trendingTagsAsks": `Homepagerightsidebar_trendingTagsAsks__uvBwg`,
	"Trending": `Homepagerightsidebar_Trending__nJw2-`,
	"tagSection": `Homepagerightsidebar_tagSection__jsvi3`,
	"Seemore": `Homepagerightsidebar_Seemore__CqHNm`,
	"asks": `Homepagerightsidebar_asks__SODPP`,
	"asksection": `Homepagerightsidebar_asksection__-M1su`,
	"trendingAsks": `Homepagerightsidebar_trendingAsks__6kbW2`,
	"contributersavatar": `Homepagerightsidebar_contributersavatar__mu73F`,
	"avatarrow": `Homepagerightsidebar_avatarrow__sjrH5`,
	"askavatar": `Homepagerightsidebar_askavatar__gntBq`,
	"askprofilecontnet": `Homepagerightsidebar_askprofilecontnet__zOPTm`,
	"askprofilecontnetName": `Homepagerightsidebar_askprofilecontnetName__0AOwa`,
	"askprofilecontnetMessage": `Homepagerightsidebar_askprofilecontnetMessage__IXnYa`,
	"contributertick": `Homepagerightsidebar_contributertick__meYlg`,
	"rightSidebar": `Homepagerightsidebar_rightSidebar__ziK+A`,
	"profilehover": `Homepagerightsidebar_profilehover__ABw55`,
	"tagName": `Homepagerightsidebar_tagName__BmPex`,
	"tagNameClicked": `Homepagerightsidebar_tagNameClicked__lY9AV`,
	"trendingTagNameContainer": `Homepagerightsidebar_trendingTagNameContainer__6cmd6`,
	"trendingTagPrivateStatus": `Homepagerightsidebar_trendingTagPrivateStatus__Wv8Hl`,
	"askImageContainer": `Homepagerightsidebar_askImageContainer__nKCzB`,
	"crownSymbol": `Homepagerightsidebar_crownSymbol__GnA5D`
};
export default ___CSS_LOADER_EXPORT___;
